import { useEffect, useState } from "react";
import { TabSelector } from "./TabSelector";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import Tag from "./Tag";
import ButtonIconH from "./ButtonIconH";
import { userData, inputOnEnter } from "../js/utils";
import { post } from "../js/post";
import moment from "moment";
import DataTable from "react-data-table-component";
import { DashboardStoreStatsPopup } from "./DashboardStoreStatsPopup";
import {
  storeDashboardBrandTable,
  storeDashboardFamilyTable,
  storeDashboardSupplierTable,
} from "../js/tableColumns";
import { useOptics } from "../hooks/useOptics";

export function DashboardStoreStatsPanel() {
  moment.locale("es");
  const [statsTabSelected, setStatsTabSelected] = useState("Familias");
  const opticalList = useOptics();
  const [selectedOpticalList, setSelectedOpticalList] = useState([]);
  const [searchYear, setSearchYear] = useState(moment());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [graphicPanel, setGraphicPanel] = useState(false);
  const [statsData, setStatsData] = useState(null);

  const clearFilters = () => {
    setSelectedOpticalList([]);
    setSearchYear(moment());
    setStartDate("");
    setEndDate("");
    setStatsData(null);
  };

  const getStatsData = async () => {
    const endpointSelected = {
      Familias:
        "support-extra/dashboard/ObtenerEstadisticasAlmacenFamiliasDashboard.php",
      Proveedores:
        "support-extra/dashboard/ObtenerEstadisticasAlmacenProveedoresDashboard.php",
      Marcas:
        "support-extra/dashboard/ObtenerEstadisticasAlmacenMarcasDashboard.php",
    };

    let opticalIdList = opticalList
      .filter((e) => selectedOpticalList.includes(e.text))
      .map((e) => e.id);
    const response = await post(endpointSelected[statsTabSelected], {
      token: userData.token,
      opticas: opticalIdList,
      ano: searchYear.year(),
      fechaDesde: startDate,
      fechaHasta: endDate,
      tipoFichero: "",
    });
    setStatsData(response);
  };

  useEffect(() => {
    if (selectedOpticalList.length > 0) getStatsData();
    else {
      setStatsData(null);
    }
  }, [selectedOpticalList, searchYear, startDate, endDate]);

  return (
    <div>
      <TabSelector
        options={["Familias", "Proveedores", "Marcas"]}
        selected={statsTabSelected}
        style={{ borderBottom: "none" }}
        onChange={(e) => {
          clearFilters();
          setStatsTabSelected(e);
        }}
      />
      <DashboardStoreStatsPopup
        tab={statsTabSelected}
        show={graphicPanel}
        onClose={() => {
          setGraphicPanel(false);
        }}
      />
      <div className="thin-section-rounded-border">
        <div className="opt-table-content grid-13" id="dashboard-store-stats">
          <div className="cell cell-start-content">Ópticas</div>
          <div className="cell">
            <InputIconSearchPanelMultiSelection
              size={0}
              tabIndex={10}
              type={"type-alphanum-ext"}
              options={opticalList.map((e) => e.text)}
              selectedOptions={selectedOpticalList}
              onChange={(e) => {
                setSelectedOpticalList(e);
              }}
            ></InputIconSearchPanelMultiSelection>
          </div>
          <div className="cell"></div>
          <div className="cell cell-start-content">Año</div>
          <div className="cell">
            <div className="data-field">
              <button
                className="incdec-btn"
                onClick={() => {
                  setSearchYear((prev) => moment(prev).subtract(1, "year"));
                }}
              >
                {"<"}
              </button>
              <span style={{ width: "35px", textAlign: "center" }}>
                {moment(searchYear).year()}
              </span>
              <button
                className="incdec-btn"
                onClick={() => {
                  setSearchYear((prev) => moment(prev).add(1, "year"));
                }}
              >
                {">"}
              </button>
            </div>
          </div>
          <div className="cell"></div>
          <div className="cell cell-start-content">Fecha desde</div>
          <div className="cell">
            <input
              type="date"
              max="9999-12-31"
              tabIndex={11}
              className="input-field"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            ></input>
          </div>
          <div className="cell"></div>
          <div className="cell cell-start-content">Fecha hasta</div>
          <div className="cell">
            <input
              type="date"
              max="9999-12-31"
              tabIndex={12}
              className="input-field"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            ></input>
          </div>
          <div className="cell">
            <button className="cell-label" onClick={clearFilters} tabIndex={-1}>
              Limpiar filtros
            </button>
          </div>
          <div className="cell cell-end-content">
            <ButtonIconH
              text="Gráficos"
              small={true}
              onClick={() => {
                setGraphicPanel(true);
              }}
            ></ButtonIconH>
          </div>
          <div className="cell combined-cells-13 cell-start-content">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                marginBottom: 10,
              }}
            >
              {selectedOpticalList.length > 0 && (
                <span style={{ fontWeight: "500", fontSize: 13 }}>
                  Ópticas seleccionadas: {selectedOpticalList.length}
                </span>
              )}
              <div className="tag-content">
                {selectedOpticalList.map((e, i) => {
                  return (
                    <Tag
                      text={e}
                      key={i}
                      tagId={i}
                      onClick={(e) => {
                        setSelectedOpticalList((prev) =>
                          prev.filter((element) => element !== e),
                        );
                      }}
                    ></Tag>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {statsTabSelected === "Familias" && (
          <div>
            {statsData !== null &&
              statsData.datosOpticas.map((e) => {
                return (
                  <div
                    style={{
                      padding: "10px 0",
                      display: "flex",
                      flexDirection: "column",
                      borderTop: "1px solid #d6d6d6",
                      width: "100%",
                      gap: 10,
                    }}
                    key={e.idOptica}
                  >
                    <span className="dashboard-section-or-title">
                      {e.idOptica} - {e.nombreOptica}
                    </span>
                    <>
                      <DataTable
                        columns={storeDashboardFamilyTable}
                        data={e.datos}
                        className="custom-datatable dashboard-custom-table non-interactive"
                        noDataComponent="No hay datos para esta óptica."
                      />
                      {e.datos.length > 0 && (
                        <DataTable
                          columns={storeDashboardFamilyTable}
                          data={[e.totales]}
                          className="custom-datatable summary-row no-header-datatable"
                        />
                      )}
                    </>
                  </div>
                );
              })}
            {statsData !== null && (
              <div
                style={{
                  padding: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  borderTop: "1px solid #d6d6d6",
                  width: "100%",
                  gap: 10,
                }}
              >
                <span className="dashboard-section-or-title">
                  Resumen global
                </span>
                <>
                  <DataTable
                    columns={storeDashboardFamilyTable}
                    data={statsData.datosTotal.datos}
                    className="custom-datatable dashboard-custom-table non-interactive"
                    noDataComponent="No hay datos globales."
                  />
                  {statsData.datosTotal.datos.length > 0 && (
                    <DataTable
                      columns={storeDashboardFamilyTable}
                      data={[statsData.datosTotal.totales]}
                      className="custom-datatable summary-row no-header-datatable"
                    />
                  )}
                </>
              </div>
            )}
          </div>
        )}
        {statsTabSelected === "Proveedores" && (
          <div>
            {statsData !== null &&
              statsData.map((e, i) => {
                return (
                  <div
                    style={{
                      padding: "10px 0",
                      display: "flex",
                      flexDirection: "column",
                      borderTop: "1px solid #d6d6d6",
                      width: "100%",
                      gap: 10,
                    }}
                    key={i}
                  >
                    <span className="dashboard-section-or-title">
                      {e.familia}
                    </span>
                    <>
                      <DataTable
                        columns={storeDashboardSupplierTable}
                        data={e.datos}
                        className="custom-datatable dashboard-custom-table non-interactive"
                        noDataComponent="No hay datos para esta familia."
                      />
                      {e.datos.length > 0 && (
                        <DataTable
                          columns={storeDashboardSupplierTable}
                          data={[e.totales]}
                          className="custom-datatable summary-row no-header-datatable"
                        />
                      )}
                    </>
                  </div>
                );
              })}
          </div>
        )}
        {statsTabSelected === "Marcas" && (
          <div>
            {statsData !== null &&
              statsData.map((e, i) => {
                return (
                  <div
                    style={{
                      padding: "10px 0",
                      display: "flex",
                      flexDirection: "column",
                      borderTop: "1px solid #d6d6d6",
                      width: "100%",
                      gap: 10,
                    }}
                    key={i}
                  >
                    <span className="dashboard-section-or-title">
                      {e.familia}
                    </span>
                    <>
                      <DataTable
                        columns={storeDashboardBrandTable}
                        data={e.datos}
                        className="custom-datatable dashboard-custom-table non-interactive"
                        noDataComponent="No hay datos para esta familia."
                      />
                      {e.datos.length > 0 && (
                        <DataTable
                          columns={storeDashboardBrandTable}
                          data={[e.totales]}
                          className="custom-datatable summary-row no-header-datatable"
                        />
                      )}
                    </>
                  </div>
                );
              })}
          </div>
        )}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ButtonIconH
            text={"Exportar"}
            small={true}
            onClick={() => {}}
          ></ButtonIconH>
        </div>
      </div>
    </div>
  );
}
